const NotFound = () => (
  <div  style={{ minHeight: window.innerHeight - 150, paddingLeft:100 }}>
    <h1>You need permission to access this site.</h1>
  </div>
);

export default NotFound;